import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LogoAsset from './LogoText.svg';
import Link from '../Link';

/**
 * Get a theme's color from passed props.variation.
 * @param {Object} props
 */
function getVariationColor({ variation, theme }) {
  switch (variation) {
    case 'yellow':
      return theme.colors.yellow.primary;
    case 'white':
      return theme.colors.grayscale.white;
    default:
      return theme.colors.grayscale.black;
  }
}

const StyledLogo = styled.div`
  svg {
    display: block;
    width: 100%;

    path:last-child {
      fill: ${getVariationColor};
    }
  }
`;

/**
 * This is a Logo Component with a SVG file.
 */
function Logo(props) {
  const { variation, LinkWrapper, onClick, id, href, ariaLabel, ...other } =
    props;

  return (
    <StyledLogo variation={variation} {...other}>
      <Link
        id={id}
        aria-label={ariaLabel}
        href={href}
        onClick={onClick}
        LinkWrapper={LinkWrapper}
      >
        <LogoAsset id={`${id}-icon`} />
      </Link>
    </StyledLogo>
  );
}

/**
 * propTypes for this component
 */
Logo.propTypes = {
  /** id associated with the logo instance */
  id: PropTypes.string,
  /** the aria label associated with the logo instance */
  ariaLabel: PropTypes.string,
  /** href this logo links to */
  href: PropTypes.string,
  /** The Link Component to wrap the link in */
  LinkWrapper: PropTypes.func,
  /** Logo's color variation. */
  variation: PropTypes.oneOf(['black', 'yellow', 'white']),
  /** onClick event handler */
  onClick: PropTypes.func,
};

/**
 * Default prop types
 */
Logo.defaultProps = {
  ariaLabel: 'SoulCycle Home Page',
  href: '/',
  id: 'soulcycle-logo',
  LinkWrapper: null,
  onClick: null,
  variation: 'black',
};

/* @component */
export default Logo;
